import { KeyLabel } from "./domainConfig";

export const allMeasurements: KeyLabel[] = [
    { key: "body_fat", label: "Body Fat", unit: "%"},
    { key: "weight", label: "Weight", unit: "kg" },
    { key: "height", label: "Height", unit: "cm" },
    { key: "head", label: "Head", unit: "cm" },
    { key: "neck", label: "Neck", unit: "cm" },
    { key: "chest", label: "Chest", unit: "cm" },
    { key: "arm_outer", label: "Outer Arm", unit: "cm" },
    { key: "waist", label: "Waist", unit: "cm" },
    { key:"waist_female", label: "Waist", unit: "cm" },
    { key: "buttocks", label: "Hip", unit: "cm" },
    { key: "leg_inner", label: "Inner Leg", unit: "cm" },
    { key: "leg_circ", label: "Thigh", unit: "cm" },
    { key: "arm_circ", label: "Bicep", unit: "cm" },
];
export const allMeasurementsFemale: KeyLabel[] = allMeasurements.filter(m => m.key !== 'waist')
export const allMeasurementsMale: KeyLabel[] = allMeasurements.filter(m => m.key !== 'waist_female')
export const allMeasurementsRetailMale: KeyLabel[] = allMeasurementsMale.filter(m => m.key !== 'leg_circ' && m.key !== 'arm_circ' && m.key!=='body_fat' && m.key!="weight"  )
export const allMeasurementsRetailFemale: KeyLabel[] = allMeasurementsFemale.filter(m => m.key !== 'leg_circ' && m.key !== 'arm_circ' &&m.key!=='body_fat' && m.key!="weight")
export const allMeasurementsFitnessMale : KeyLabel[] = allMeasurementsMale.filter(m => m.key !== 'leg_inner' && m.key !== 'arm_outer')
export const allMeasurementsFitnessFemale : KeyLabel[] = allMeasurementsFemale.filter(m => m.key !== 'leg_inner' && m.key !== 'arm_outer')

// Derived on the client and only rendered where Config.showMuscleMass is on.
// Kept out of the lists above so the dashboard, avatar and feedback views are
// unaffected.
export const muscleMeasurements: KeyLabel[] = [
    { key: "muscle_mass", label: "Muscle Mass", unit: "kg" },
    { key: "muscle_percent", label: "Muscle", unit: "%" },
]